module.exports = "//img1.rrcimg.com/_next/static/src/assets/dl_1R-cO.png";